import { Obstruction } from '../obstruction.class';

export const isGrillIslandCfn = (island: Obstruction): boolean => {
	// Use panels to find grill appliances, return true if one is found
	console.log('TODO: isGrillIsland', island);

	return false;
};
